// Frame 10 — app shell, no access (33:3013): a 560px `State/Error` panel
// centred in the body. Unlike the six `S1` auth frames, this one DOES instance
// `Screen/Template` (44:2491), so it renders inside `AppShell` — but only once
// `GET /auth/me` has named an org the shell can legitimately be scoped to. A
// caller with no session has no org, and a sidebar pointed at the org they were
// just refused is not chrome, it is a lie.
//
// IT MUST NOT SAY WHETHER THE ORG EXISTS. `require_org` answers 404 rather than
// 403 on every authorisation failure precisely so a probe cannot confirm a
// guessed tenant slug; a screen that echoes the requested slug, or distinguishes
// "no such workspace" from "not yours", hands back the oracle the backend spent
// a status code to close. Nothing here reads the requested slug at all.

import { AppShell } from "../../shell/AppShell";
import { hrefs, orgNav } from "../../shell/hrefs";
import { Button, ErrorState } from "../../ui";
import { signOut, useMe } from "./api";
import "./overview.css";

export function NoAccessScreen() {
  const me = useMe();
  const org = me.data?.org_slug ?? null;

  const panel = (
    <div className="maisight-overview-panel">
      <ErrorState
        headline="You do not have access to this organisation"
        detail="Ask an admin of that workspace to invite you, or switch back to one you belong to."
        action={
          me.isPending ? undefined : org ? (
            <Button to={hrefs(org).overview} variant="primary">
              Switch workspace
            </Button>
          ) : (
            <Button to="/signin" variant="primary">
              Sign in
            </Button>
          )
        }
      />
    </div>
  );

  // Signed out: no org to build a shell around, and nothing to sign out of.
  // `data-chassis="paper"` is not decoration — every rule in `ui.css` is scoped
  // under it, so without it this panel renders unstyled.
  if (!org)
    return (
      <div className="maisight-overview-bare" data-chassis="paper">
        {panel}
      </div>
    );

  return (
    <AppShell nav={orgNav(org)} title="No access" onSignOut={signOut}>
      <div className="maisight-overview">{panel}</div>
    </AppShell>
  );
}
